export enum ESelectRevisionModalType {
  T2 = 'T2',
  T3 = 'T3',
  T4 = 'T4',
}
